import { VFC } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { updateScheduleUrl } from 'src/api/user'
import { PROFILE_SCHEDULE_URL_EXAMPLE } from 'src/assets/images'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { SmallButton } from 'src/elements/Button'
import {
  _formalert,
  _profilegreen,
  black,
  contributionGray,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { ScheduleUrlInput } from '../../Profile/ScheduleUrl/ScheduleUrlForm'

const DESCRIPTION =
  '「つながり申請」や「メッセージ」を送信した際に、相手のメッセージ画面にあなたの日程調整URLが自動表示されます。'

const ScheduleUrl: VFC<ModalProps<{ id: string; mutateRequestBox: any }>> = ({
  close,
  id,
  mutateRequestBox,
}) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm()

  const handleOnSubmit: SubmitHandler<{ scheduleUrl: string }> = async ({
    scheduleUrl,
  }) => {
    const res = await updateScheduleUrl(scheduleUrl)

    if (res.error) setError(id, { message: 'URLの入力に誤りがあります。' })
    else {
      mutateRequestBox()
      close()
    }
  }

  return (
    <Layout>
      <FormTitle>日程調整URL登録</FormTitle>
      <FormCaption>{DESCRIPTION}</FormCaption>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <FormLabel htmlFor={id}>日程調整URL</FormLabel>
        <ScheduleUrlInput id={id} register={register} required />
        <ErrorMessage>
          <p>{errors.scheduleUrl && errors.scheduleUrl.message}</p>
        </ErrorMessage>
        <ModalButtons>
          <CancelButton type="button" onClick={close}>
            キャンセル
          </CancelButton>
          <SaveButton type="submit" disabled={isSubmitting}>
            設定する
          </SaveButton>
        </ModalButtons>
        <Description>
          <p>{DESCRIPTION}</p>
          <img src={PROFILE_SCHEDULE_URL_EXAMPLE} alt="schedule_url" />
        </Description>
      </form>
    </Layout>
  )
}

export const ScheduleUrlModal = asModal(ScheduleUrl, { scrollable: true })

const Layout = styled.div`
  width: 80vw;
  max-width: 700px;
  padding: 5%;
  border-radius: 10px;
  background-color: ${truewhite};
  line-height: 1.3rem;
  max-height: 80vh;
  overflow-y: auto;

  h2 {
    width: 100%;
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: ${fontWeightBold};

    @media screen and (max-width: 540px) {
      font-size: 15px;
    }
  }

  p {
    @media screen and (max-width: 540px) {
      font-size: 10px;
      line-height: 1rem;
    }
  }

  input {
    width: 100%;
    border: 1px solid #cdcdcd;
    border-radius: 3px;
  }
`

const FormTitle = styled.h1`
  margin-bottom: 20px;

  font-size: 24px;
  font-weight: ${fontWeightBold};
  text-align: left;
`

const FormLabel = styled.label`
  font-size: 14px;
  font-weight: ${fontWeightBold};
  text-align: left;
  color: ${contributionGray};
`

const FormCaption = styled.p`
  margin-bottom: 20px;
  font-size: 14px;
  color: ${black};
`

const ErrorMessage = styled.div`
  color: ${_formalert};
  margin-top: 10px;
`

const ModalButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-end;

  @media screen and (max-width: 540px) {
    display: block;
  }
`

const SaveButton = styled(SmallButton)`
  color: ${truewhite};
  background: ${_profilegreen};
`

const CancelButton = styled(SmallButton)`
  color: ${_profilegreen};
`

const Description = styled.div`
  margin-top: 40px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #cdcdcd;

  p {
    font-size: 14px;
    color: #606060;
  }

  img {
    width: 100%;
    margin-top: 8px;
  }
`
